<div class="wrpr">
  <div class="homePageCont">
      <h1>Tyre Pairing</h1>
      <div class="contentCard">
          <h3>Select an option below to get started</h3>
          <div class="btnCont">
              <button class="primary" onKeyPress="" (click)="onCreateNewRequest()">
                  Pairing Request
              </button>
              <button [disabled]="!isInsightsAllowed" class="primary" (click)="goToInsights()">
                Pairing Insights
              </button>
          </div>
      </div>
  </div>
</div>
